module.exports = __webpack_public_path__ + "static/img/big002.f0e8ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big002.png
// module id = GfPI
// module chunks = 1